var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.26,
    height: 29.131,
    viewBox: "0 0 23.26 29.131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3140",
    "data-name": "Rectangle 3140",
    width: 23.26,
    height: 29.131,
    transform: "translate(-2 -2)",
    fill: "#2e728c",
    stroke: "#2e728c",
    strokeWidth: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11046",
    "data-name": "Group 11046",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11045",
    "data-name": "Group 11045",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28988",
    "data-name": "Path 28988",
    d: "M.9,17.263,0,24.545a.53.53,0,0,0,.523.586H18.733a.53.53,0,0,0,.523-.586l-.894-7.282a.531.531,0,0,0-.273-.4L13.2,14.247l-.907-1.15V11.872a5.768,5.768,0,0,0,2.347-4.493,3.027,3.027,0,0,0,.638-2.961A6.5,6.5,0,0,0,11.32.176,2.688,2.688,0,0,0,8.907.4,1.785,1.785,0,0,0,8.687.209a1.58,1.58,0,0,0-1.6,0A5.868,5.868,0,0,0,3.945,4.579a2.714,2.714,0,0,0,.679,2.094v.209A6.072,6.072,0,0,0,6.986,11.8v1.254l-.775,1H6.17L1.181,16.845a.529.529,0,0,0-.284.417m8.769,6.805H8.8L9.368,19a.567.567,0,0,0,0-.256L8.7,17.12l.949-.725.979.753-.665,1.57a.51.51,0,0,0-.033.256l.581,5.082ZM7.509,14.081l1.363,1.57-1.279.984-.6-1.895Zm4.242,0,.523.665-.6,1.895-1.257-.984Zm.684,3.585.722-2.266,4.188,2.26.785,6.423H11.546l-.58-5.069.523-1.207.15.114a.524.524,0,0,0,.318.109.507.507,0,0,0,.159,0,.515.515,0,0,0,.318-.365M4.981,4.715a4.818,4.818,0,0,1,2.465-3.5c.4-.2.609-.169.635-.152a1.043,1.043,0,0,1,.292.382.522.522,0,0,0,.9.057c.319-.461.912-.57,1.76-.32a5.551,5.551,0,0,1,3.233,3.5,2.091,2.091,0,0,1-.188,1.729l-.272-.1c-1.9-.75-3.7-1.45-4.359-3.367a.526.526,0,0,0-.489-.335H8.844a.523.523,0,0,0-.428.523A3.462,3.462,0,0,1,5.357,5.934a1.649,1.649,0,0,1-.376-1.219m.681,2.252A4.627,4.627,0,0,0,8.525,5.359a4.5,4.5,0,0,0,.548-.848c1.023,1.467,2.707,2.127,4.346,2.77l.169.068c-.131,2.443-1.824,4.319-3.959,4.319S5.7,9.563,5.662,6.968M9.63,12.726a4.585,4.585,0,0,0,1.612-.295v.644L9.63,14.923,8.018,13.055V12.4a4.411,4.411,0,0,0,1.612.313ZM1.9,17.655l4.188-2.328.744,2.34a.525.525,0,0,0,.341.341.485.485,0,0,0,.156,0,.519.519,0,0,0,.32-.109l.179-.137.523,1.23-.607,5.093H1.118Z",
    transform: "translate(0 0)",
    fill: "#2e728c",
    stroke: "#2e728c",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.4efb9dad3afce5f45ffbce509054a1fa.svg";
export { ForwardRef as ReactComponent };